<template>
  <contact-form></contact-form>
</template>

<script>
import ContactForm from '@/components/ContactForm.vue'
import {mapActions} from 'vuex'

export default {
  components: { ContactForm },
  mounted() {
    this.updateWindowTitle({ newTitle: "Contact Us" });
  },
  methods: {
    ...mapActions(["updateWindowTitle"]),
  }
}
</script>

<style>

</style>